import * as yup from "yup";
import { fieldAtLeastOneRequired } from "../../../../common/infrastructure/helpers/yupHelper";

export const bulkAssignInstructorFormSchema = yup
  .object({
    employeeId: yup
      .number()
      .nullable()
      .required("Моля изберете инструктор.")
      .min(1, "Моля изберете инструктор."),
    eventIds: yup
      .array()
      .of(yup.number().required())
      .min(1, fieldAtLeastOneRequired("клас"))
      .required(),
  })
  .required();

export type IBulkAssignInstructorFormModel = yup.InferType<
  typeof bulkAssignInstructorFormSchema
>;

export const bulkAssignInstructorFormDefaultValues: IBulkAssignInstructorFormModel =
  {
    employeeId: null as unknown as number,
    eventIds: [],
  };
